import { render } from "./VvPointsCard.vue?vue&type=template&id=89e38124&scoped=true"
import script from "./VvPointsCard.vue?vue&type=script&lang=js"
export * from "./VvPointsCard.vue?vue&type=script&lang=js"

import "./VvPointsCard.vue?vue&type=style&index=0&id=89e38124&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e38124"]])

export default __exports__